export const TIKTOK_PIXEL_ID = process.env.REACT_APP_TIKTOK_ID;
export const TTP_PARAM = '_ttp';
